<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
    <button type="button" class="navbar-toggler navbar-toggler-right" :class="{ toggled: $sidebar.showSidebar }"
        aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" @click="toggleSidebar">
        <i class="fa-solid fa-x"></i>
      </button>
    </li>
    <li class="nav-item">
      <a href="#" class="nav-link link-logout" @click="logout" style="background: none;">
        <i class="fas fa-sign-out-alt logoutMobile" style="font-size: 16px; width:100%;"><span class="mx-1"> تسجيل خروج</span></i>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'mobile-menu',
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    // toggleNotificationDropDown() {
    //   this.activeNotifications = !this.activeNotifications
    // },
    // closeDropDown() {
    //   this.activeNotifications = false
    // },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("expirationTime");
      this.$router.push("/login");
    },
  },
};
</script>
<style scoped>
.logoutMobile:hover{
  color: rgb(241, 47, 47);
}
</style>
